import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {UserDetailStatus, type UserDetails} from "@vesta/vos-types/modules/platformLevel/userDetails/domain/UserDetails.ts";

// TODO: Think of a better name
export type RawPlatformUser = {
    id: Uuid;
    name: string | null;
    email: string | null;
    phoneNumber: string | null;
    userId: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
};

export const rawPlatformUserValidator: zod.ZodType<RawPlatformUser> = zod.object({
    name: zod.string().nullable(),
    email: zod.string().nullable(),
    phoneNumber: zod.string().nullable(),
    id: uuidZodValidator,
    userId: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});

export type PlatformUser = UserDetails & {
    name: string;
};

export const platformUserValidator: zod.ZodType<PlatformUser> = zod.object({
    name: zod.string().trim().min(1),
    email: zod.string().nullable(),
    phoneNumber: zod.string().nullable(),
    // Not using them right now, but keeping them here for future use
    id: uuidZodValidator,
    userId: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    updatedBy: uuidZodValidator,
    status: zod.enum(UserDetailStatus),
});

export function isCompletePlatformUser(user: UserDetails): user is PlatformUser {
    return user.name !== null && user.name.trim().length > 0;
}
